export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-480w.b2b1618f.webp";